<ng-container [ngSwitch]="visibilityClv">
  <ng-container *ngSwitchCase="visibilityClasses.Freezed">
    <span title="Freezed">
      <svg viewBox="0 0 8 8" class="icon small text-gray-500 mb-1" [inlineSVG]="'#lock-closed'">
      </svg>
    </span>
  </ng-container>
  <ng-container *ngSwitchCase="visibilityClasses.Hidden">
    <span title="Hidden">
      <svg viewBox="0 0 8 8" class="icon small text-gray-500 mb-1" [inlineSVG]="'#eye-slash'">
      </svg>
    </span>
  </ng-container>
  <ng-container *ngSwitchCase="visibilityClasses.Optional">
    <span title="Optional">
      <svg viewBox="0 0 8 8" class="icon small text-gray-500 mb-1" [inlineSVG]="'#swatch'">
      </svg>
    </span>
  </ng-container>
  <ng-container *ngSwitchCase="visibilityClasses.Required">
    <span title="Required">
      <svg viewBox="0 0 8 8" class="icon small text-gray-500 mb-1" [inlineSVG]="'#check-circle'">
      </svg>
    </span>
  </ng-container>
  <ng-container *ngSwitchDefault></ng-container>
</ng-container>
